import { PhoneBase } from '../../../../baseBtl/catalog/products/equipement/complex/phone';

/**
 * The Phone class
 * See {@link Attribute} to see how it is used
 */
export class Phone extends PhoneBase {
    hasEresa(): boolean {
        return (
            this &&
            this.stock &&
            (!this.stock.eresa.cart || !this.data.in_stock || this.qty === 0) &&
            !this.stock.preresa &&
            this.stock.eresa.active &&
            !this.exclu_web
        );
    }
}
